import { get, post } from '@/lib/api/client'
import type { ApiResponse, LegalFoundation, LegalFoundationFilterParams, PaginatedResponse, PaginationParams } from '@/lib/api/types'
import { createQueryString } from '@/utils/helpers/createQueryString'

export class LegalFoundationService {
  /**
   * Get all published legal foundations (public endpoint)
   * GET /legal-foundations/public/all
   */
  async getPublishedLegalFoundations(): Promise<ApiResponse<LegalFoundation[]>> {
    return await get<ApiResponse<LegalFoundation[]>>('legal-foundations/public/all')
  }

  /**
   * Search legal foundations by a search term (public endpoint)
   * GET /legal-foundations/public/search?query={searchTerm}&page={page}&size={size}
   * @param searchTerm The term to search legal foundations by
   * @param params Pagination parameters (page number and size)
   */
  async searchLegalFoundations(searchTerm: string, params: PaginationParams): Promise<ApiResponse<PaginatedResponse<LegalFoundation>>> {
    const query = createQueryString({...params, searchBy: searchTerm})
    return await get<ApiResponse<PaginatedResponse<LegalFoundation>>>(`legal-foundations/public/search?${query}`)
  }

  /**
   * Filter legal foundations by criteria (public endpoint)
   * GET /legal-foundations/public/filter?{filters}&page={page}&size={size}
   * @param filters The filter criteria as key-value pairs (e.g., category, year)
   * @param params Pagination parameters (page number and size)
   */
  async filterLegalFoundations(filters: LegalFoundationFilterParams, params: PaginationParams): Promise<ApiResponse<PaginatedResponse<LegalFoundation>>> {
    const query = createQueryString(params)
    return await post<ApiResponse<PaginatedResponse<LegalFoundation>>>(`legal-foundations/public/filter?${query}`, {
      ...filters,
    })
  }
}

export const legalFoundationService = new LegalFoundationService()

export default legalFoundationService
